import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./c4PDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper"



export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
  });

  const grouped = groupByShop(rows);


  //console.log("Grouped Data:", grouped);
  let firstPage = true;

//drawWatermark (doc);

  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(doc, shop, grouped[shop].rows, grouped[shop].total);
    });



//drawGrandTotal(doc, grandTotal);
  

  drawFooter(doc, month, year, title);



 handlePdf(doc, PDF_ACTION.VIEW);
}


function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.userid ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          DrAmount: 0,
          CrAmount: 0,
          total: 0,
          
        },
      };
    }

    groups[shop].rows.push(row);

    groups[shop].total.DrAmount += Number(row.DrAmount || 0);
    groups[shop].total.CrAmount += Number(row.CrAmount || 0);
    groups[shop].total.total += (Number(row.DrAmount || 0)-  Number(row.CrAmount || 0));
    

    return groups;
  }, {});
}